import Grid from '@mui/material/Grid';
import { Outlet } from 'react-router-dom';

import SearchBar from './SearchBar';

const Search = () => {
  return (
    <Grid
      container
      sx={{
        height: '100%',
        paddingTop: 0,
      }}
    >
      <Grid item xs={4}>
        <SearchBar />
      </Grid>
      <Grid item xs={8}>
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default Search;
